import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from './calendarViewInterviews.module.scss';

const CalendarDatePicker = ({ selectedDate, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDatePicker = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.calendar_date_picker}>
      <svg width="21" height="23" className={styles.calendarIcon} onClick={toggleDatePicker} viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.0625 9.40283H1.0625M14.0625 1.40283V5.40283M6.0625 1.40283V5.40283M8.5625 13.4028L10.0625 12.4028V17.4028M8.8125 17.4028H11.3125M5.8625 21.4028H14.2625C15.9427 21.4028 16.7827 21.4028 17.4245 21.0759C17.989 20.7882 18.4479 20.3293 18.7355 19.7648C19.0625 19.1231 19.0625 18.283 19.0625 16.6028V8.20283C19.0625 6.52267 19.0625 5.6826 18.7355 5.04086C18.4479 4.47637 17.989 4.01743 17.4245 3.72981C16.7827 3.40283 15.9427 3.40283 14.2625 3.40283H5.8625C4.18234 3.40283 3.34226 3.40283 2.70053 3.72981C2.13604 4.01743 1.6771 4.47637 1.38948 5.04086C1.0625 5.6826 1.0625 6.52267 1.0625 8.20283V16.6028C1.0625 18.283 1.0625 19.1231 1.38948 19.7648C1.6771 20.3293 2.13604 20.7882 2.70053 21.0759C3.34226 21.4028 4.18234 21.4028 5.8625 21.4028Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      {isOpen && (
        <div className={styles.calendar_container}>
          <DatePicker
            open={true}
            inline
            selected={selectedDate}
            onChange={onChange}
            onClickOutside={toggleDatePicker}
          />
        </div>
      )}
    </div>
  );
};

export default CalendarDatePicker;
